/* eslint-disable */
export const FORM_VALIDATION_CONSTANTS = {
    email: /^[a-z][a-zA-Z0-9_]*(\.[a-zA-Z][a-zA-Z0-9_]*)?@[a-z][a-zA-Z-0-9]*\.[a-z]+(\.[a-z]+)?$/,
    password: /^.{8,}$/,
    organisationName:/^[a-zA-Z][a-zA-Z0-9 ]*$/,
    name:/^[a-zA-Z][a-zA-Z0-9 ]*$/,
    verificationCode:/^[0-9\b]+$/,
    phoneNumber:/[2-9]{2}\d{8}/
};